const images = document.querySelectorAll('[data-content-block-image]')

if ("IntersectionObserver" in window) {
  const imageObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        const image = entry.target
        image.src = image.dataset.src
        image.srcset = image.dataset.srcset
        imageObserver.unobserve(image)
      }
    })
  })

  Array.prototype.forEach.call(images, image => {
    imageObserver.observe(image)
  })
} else {
  Array.prototype.forEach.call(images, image => {
    image.src = image.dataset.src
    image.srcset = image.dataset.srcset
  })
}
